import { useQuery } from "@tanstack/react-query";
import { cashAppLocal } from "@squareup/dashboard-query/queries/cash-app-local";
function useCashAppDefaultBrand() {
  return useQuery(cashAppLocal.defaultBrand());
}
export {
  useCashAppDefaultBrand
};
//# sourceMappingURL=useCashAppDefaultBrand.js.map
